var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { appear: "", name: "init-fade" } }, [
    _c(
      "div",
      {
        staticClass: "page",
        class: {
          "page--merchandising-banner":
            _vm.$config.homeMerchandisingBanner &&
            !_vm.recentlyViewedEvents.length > 0
        }
      },
      [
        _c(
          "div",
          [
            _vm.$config.merchandisingBanner
              ? _c("section", { staticClass: "merchandising-banner" }, [
                  _c("img", {
                    staticClass: "merchandising-banner__img--desktop",
                    attrs: {
                      alt: _vm.$config.merchandisingBanner.desktop.alt,
                      src:
                        _vm.$store.state.imagesCdn +
                        "/" +
                        _vm.$config.merchandisingBanner.desktop.staticImagePath
                    }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "merchandising-banner__img--mobile",
                    attrs: {
                      alt: _vm.$config.merchandisingBanner.mobile.alt,
                      src:
                        _vm.$store.state.imagesCdn +
                        "/" +
                        _vm.$config.merchandisingBanner.mobile.staticImagePath
                    }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("transition", { attrs: { name: "fade" } }, [
              _vm.recentlyViewedEvents.length > 0
                ? _c(
                    "section",
                    { staticClass: "recently-viewed" },
                    [
                      _c("header", [_c("h1", [_vm._v("Recently Viewed")])]),
                      _vm._v(" "),
                      _c(
                        "transition-group",
                        {
                          staticClass: "recently-viewed__events",
                          attrs: { name: "fade", tag: "ul" }
                        },
                        _vm._l(_vm.recentlyViewedEvents, function(
                          event,
                          index
                        ) {
                          return _c(
                            "li",
                            {
                              key: event.id,
                              staticClass: "recently-viewed__event fade-item"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "recently-viewed__event-inner" },
                                [
                                  _c("button", {
                                    staticClass: "icon-close",
                                    on: {
                                      click: function($event) {
                                        _vm.removeRecentEventAt(index)
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "event-link",
                                      attrs: { to: _vm.makeEventRoute(event) },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.onClickRecentlyViewed(
                                            $event
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "event-details" },
                                        [
                                          _c("div", {
                                            staticClass: "image",
                                            style: {
                                              backgroundImage:
                                                "url(" +
                                                (event.imageUrlSquare ||
                                                  event.imageUrlRectangle) +
                                                ")"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "details" },
                                            [
                                              _c(
                                                "v-clamp",
                                                {
                                                  staticClass: "event",
                                                  attrs: {
                                                    "max-lines": 2,
                                                    autoresize: ""
                                                  }
                                                },
                                                [_vm._v(_vm._s(event.name))]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "details__secondary"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "date" },
                                                    [
                                                      event.isDateTbd
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "date--emphasized"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Date TBD"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        : event.isTimeTbd
                                                        ? _c("span", [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "date--emphasized"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "date"
                                                                    )(
                                                                      event.localDate,
                                                                      "MMM D"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              ", " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "date"
                                                                  )(
                                                                    event.localDate,
                                                                    "YYYY"
                                                                  )
                                                                ) +
                                                                ", "
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "date--emphasized"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "Time TBD"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        : event.localDateLabel
                                                        ? _c("span", [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "date--emphasized"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    event.localDateLabel
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              " at " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "date"
                                                                  )(
                                                                    event.localDate,
                                                                    "h:mma"
                                                                  )
                                                                ) +
                                                                "\n                                                        "
                                                            )
                                                          ])
                                                        : _c("span", [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "date--emphasized"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "date"
                                                                    )(
                                                                      event.localDate,
                                                                      "MMM D"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              ", " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "date"
                                                                  )(
                                                                    event.localDate,
                                                                    "YYYY"
                                                                  )
                                                                ) +
                                                                " at " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "date"
                                                                  )(
                                                                    event.localDate,
                                                                    "h:mma"
                                                                  )
                                                                )
                                                            )
                                                          ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "location"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              event.venueCity
                                                            ) +
                                                              ", " +
                                                              _vm._s(
                                                                event.venueRegionCode
                                                              )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "event-details-cta-wrapper"
                                                    },
                                                    [
                                                      _c("span", {
                                                        staticClass:
                                                          "event-details-cta icon-chevron-lg-right"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        })
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.$config.homeMerchandisingBanner
              ? _c("Banner", {
                  staticClass: "home-merchandising-banner",
                  attrs: {
                    "background-image":
                      _vm.$store.state.imagesCdn +
                      "/" +
                      _vm.$config.homeMerchandisingBanner.staticImagePath,
                    tagline: _vm.$config.homeMerchandisingBanner.tagline,
                    title: _vm.$config.homeMerchandisingBanner.title
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.hasCustomTaxonomyView
              ? _c(
                  "section",
                  {
                    staticClass: "filters",
                    class: {
                      "filters--no-featured": _vm.featuredEvents.length === 0
                    }
                  },
                  [
                    _c("LocationFilter", {
                      attrs: {
                        "default-location": _vm.$config.defaultLocation
                          ? _vm.$config.defaultLocation
                          : _vm.userLocation,
                        location: _vm.location
                      },
                      on: {
                        error: _vm.onLocationError,
                        select: _vm.onLocationSelect
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "date-filter" },
                      [
                        _c("span", { staticClass: "icon-calendar-blank" }),
                        _vm._v(" "),
                        _c(
                          "fx-date-range",
                          {
                            attrs: {
                              align: "left",
                              "data-e2e": "home.date-filter",
                              "min-date": "today",
                              "custom-option-copy": "Choose Date",
                              "default-option-copy": "Any Date",
                              presets: _vm.dateRangeFilterPresets
                            },
                            on: { input: _vm.onDateRangeInput },
                            model: {
                              value: _vm.dateRange,
                              callback: function($$v) {
                                _vm.dateRange = $$v
                              },
                              expression: "dateRange"
                            }
                          },
                          [
                            _c("span", {
                              staticClass: "icon-chevron-lg-down",
                              attrs: { slot: "caret" },
                              slot: "caret"
                            })
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("transition", { attrs: { appear: "", name: "fade" } }, [
              _vm.featuredEvents.length
                ? _c(
                    "section",
                    [
                      _c(
                        "transition",
                        { attrs: { mode: "out-in", name: "fade" } },
                        [
                          _c("FeaturedEvents", {
                            key: _vm.featuredEventsId,
                            attrs: { featuredEvents: _vm.featuredEvents }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "filters-wrapper" }, [
              _c(
                "section",
                { staticClass: "segment-filter" },
                [
                  _c("div", { staticClass: "segment-filter__shop-by" }, [
                    _vm._v("Shop by ")
                  ]),
                  _vm._v(" "),
                  _c("Tabs", {
                    attrs: {
                      "default-item": _vm.categoryItems[0],
                      items: _vm.categoryItems
                    },
                    on: {
                      "reset-tabs-dropdown": function($event) {
                        _vm.$router.push(_vm.makeCategoryRoute({}))
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.hasCustomTaxonomyView
                ? _c(
                    "section",
                    {
                      staticClass: "filters capital-one-filters",
                      class: {
                        "filters--no-featured": _vm.featuredEvents.length === 0
                      }
                    },
                    [
                      _c("LocationFilter", {
                        attrs: {
                          "default-location": _vm.$config.defaultLocation
                            ? _vm.$config.defaultLocation
                            : _vm.userLocation,
                          location: _vm.location,
                          locationFilterCopy: "Near"
                        },
                        on: {
                          error: _vm.onLocationError,
                          select: _vm.onLocationSelect
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "date-filter" },
                        [
                          _c("span", { staticClass: "icon-calendar-blank" }),
                          _vm._v(" "),
                          _c(
                            "fx-date-range",
                            {
                              attrs: {
                                align: "left",
                                "data-e2e": "home.date-filter",
                                "min-date": "today",
                                "custom-option-copy": "Choose Date",
                                "default-option-copy": "Any Date",
                                presets: _vm.dateRangeFilterPresets
                              },
                              on: { input: _vm.onDateRangeInput },
                              model: {
                                value: _vm.dateRange,
                                callback: function($$v) {
                                  _vm.dateRange = $$v
                                },
                                expression: "dateRange"
                              }
                            },
                            [
                              _c("span", {
                                staticClass: "icon-chevron-lg-down",
                                attrs: { slot: "caret" },
                                slot: "caret"
                              })
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "section",
              [
                _c("EventList", {
                  attrs: {
                    events: _vm.events,
                    "format-points": _vm.formatPoints,
                    "is-loading-events": _vm.isLoadingEvents,
                    "is-loading-more-events": _vm.isLoadingMoreEvents,
                    "is-loyalty-pricing": _vm.isLoyaltyPricing,
                    "load-more-copy": "Show More",
                    "loading-more-copy": "Loading More Events...",
                    "make-event-route": _vm.makeEventRoute,
                    "on-event-click": _vm.onEventClick,
                    pagination: _vm.pagination
                  },
                  on: { "load-more-events": _vm.onLoadMoreEvents }
                })
              ],
              1
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }